import axios from 'axios';
import { createContext, useContext, useEffect, useState } from 'react';
import { useSnackbar } from '../../../commons/snackBarContextProvider';
import ThrowError from '../../utils/errors';
import { TENANT_URL } from '../../../config';

const DistributorContext = createContext();
const DistributorProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [allDistributorData, setAllDistributorData] = useState([]); 
  const [DistributorData, setDistributorData] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [noOfPages, setNoOfPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const { show } = useSnackbar();

  const addData = async (userData) => {
    userData.is_active = true;
    var data = JSON.stringify(userData);
    const token = JSON.parse(localStorage.getItem('userdata')).token;

    const setData = {
      method: 'post',
      url: `${TENANT_URL}/distributor`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    };

    setLoading(true);

    try {
      await axios({ ...setData, data: data });
      show('Distributor Added Successfully');
      await getCurrentPage(currentPage);
    } catch (error) {
      ThrowError(error, show);
    }

    setLoading(false);
  };

  const getSingleData = async (id) => {

    const token = JSON.parse(localStorage.getItem('userdata')).token;
    const getConfig = {
      method: 'get',
      url: `${TENANT_URL}/distributor/${id}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    setLoading(true);
    try {
      const response = await axios(getConfig);

      setDistributorData(response.data.data);
    } catch (error) {
      console.error(error);
      show('User Not Found', 'error');
    }
    setLoading(false);
  };

  const getCurrentPage = async (pageNo) => {
    setCurrentPage(pageNo);
    const token = JSON.parse(localStorage.getItem('userdata')).token;
    const getConfig = {
      method: 'get',
      url: `${TENANT_URL}/distributor?page=${currentPage}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    try {
      const response = await axios(getConfig);
      setAllDistributorData(response.data.data);
    } catch (error) {
      console.error(error);
      show('Data not Updated', 'error');
    }
  };

  const getPage = async (pageNo) => {
    const token = JSON.parse(localStorage.getItem('userdata')).token;
    const getConfig = {
      method: 'get',
      url: `${TENANT_URL}/distributor?page=${pageNo}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    try {
      const response = await axios(getConfig);
      setRowsPerPage(response.data.meta.per_page);
      setCurrentPage(response.data.meta.current_page);
      setNoOfPages(Math.ceil(response.data.meta.total / 10));
      setTotalRecords(response.data.meta.total);
    } catch (error) {
      console.error(error);
      show('Data not Updated', 'error');
    }
  };

  const deleteMech = async (id) => {
    const token = JSON.parse(localStorage.getItem('userdata')).token;
    var deleteConfig = {
      method: 'delete',
      url: `${TENANT_URL}/distributor/${id}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      await axios(deleteConfig);
      await getCurrentPage(currentPage);
      show('Distributor Deleted Successfully');
    } catch (error) {
      console.error(error);
      show('Distributor Not Deleted', 'error');
    }
  };

  const updateData = async (userData, id) => {
    var data = JSON.stringify(userData);
    const token = JSON.parse(localStorage.getItem('userdata')).token;

    const setData = {
      method: 'put',
      url: `${TENANT_URL}/distributor/${id}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    };
    setLoading(true);
    try {
      await axios({ ...setData, data: data });
      show('Distributor Updated');
      await getCurrentPage(currentPage);
    } catch (error) {
      ThrowError(error, show);
    }
    setLoading(false);
  };

  const active = async (id) => {
    const token = JSON.parse(localStorage.getItem('userdata')).token;
    var getConfig = {
      method: 'get',
      url: `${TENANT_URL}/active/distributor/${id}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      await axios(getConfig);
      await getCurrentPage(currentPage);
    } catch (error) {
      console.error(error);
    }
  };

  const searchDistributors = async (searchData) => {
    var data = JSON.stringify(searchData);
    const token = JSON.parse(localStorage.getItem('userdata')).token;
    const setData = {
      method: 'post',
      url: `${TENANT_URL}/search/distributor`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    };

    setLoading(true);
    try {
      const response = await axios({ ...setData, data: data });
      setAllDistributorData(response.data.data);
      setRowsPerPage(100);
      setCurrentPage(1);
      setNoOfPages(1);
      setTotalRecords(10);
    } catch (error) {
      ThrowError(error, show);
    }
    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);
    getPage();
    setLoading(false);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getCurrentPage(currentPage);

    // eslint-disable-next-line
  }, [currentPage]);

  const contextValue = {
    setLoading,
    loading,
    addData,
    allDistributorData,
    getSingleData,
    DistributorData,
    getCurrentPage,
    deleteMech,
    updateData,
    active,
    rowsPerPage,
    currentPage,
    noOfPages,
    getPage,
    totalRecords,
    searchDistributors,
  };

  return (
    <DistributorContext.Provider value={contextValue}>
      {children}
    </DistributorContext.Provider>
  );
};

const useDistributor = () => useContext(DistributorContext);

export { DistributorProvider, useDistributor };
